import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getYzRefs = () => httpClient.get(apis.GET_YZ_REFS);
export const chooseYzRefs = (payload) =>
  httpClient.post(apis.CHOOSE_YZ_REFS, payload, { ignore: true });
